let hexToRgb = (hex) => {
  const result = /^#?([a-f\d]{2})([a-f\d]{2})([a-f\d]{2})$/i.exec(hex);
  return result
    ? {
        r: parseInt(result[1], 16),
        g: parseInt(result[2], 16),
        b: parseInt(result[3], 16),
      }
    : null;
};

let preferentialVerticalProperty = ($event) => {
  let target = $event.target;
  let boundingRectangle = target.getBoundingClientRect();
  let windowHeight = window.innerHeight;
  if (windowHeight - boundingRectangle.top < boundingRectangle.top) {
    return "bottom";
  } else {
    return "top";
  }
};

export { hexToRgb, preferentialVerticalProperty };
